/**
 * @generated SignedSource<<095a806239f33a9c0b46a18f71de4b76>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LocationKind = "HYBRID" | "IN_PERSON" | "ONLINE";
import { TimeZone } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type EventLocationFragment$data = {
  readonly timeline: {
    readonly endDate: any;
    readonly location: {
      readonly city: string;
      readonly country: string;
    } | null | undefined;
    readonly locationKind: LocationKind;
    readonly startDate: any;
    readonly timezone: TimeZone;
  } | null | undefined;
  readonly " $fragmentType": "EventLocationFragment";
};
export type EventLocationFragment$key = {
  readonly " $data"?: EventLocationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventLocationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventLocationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Timeline",
      "kind": "LinkedField",
      "name": "timeline",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locationKind",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Location",
          "kind": "LinkedField",
          "name": "location",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "city",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "5c97bc07e8ad5f52342e877d42803b85";

export default node;
